import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { OrderURLsTable } from '../../../../types'

interface ModalSyncProductPriceOrderProps extends ModalEditComponentProps {
    orderURLs: OrderURLsTable
}

const ModalSyncProductPriceOrder: React.FC<ModalSyncProductPriceOrderProps> = ({ orderURLs, setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit: onSubmit,
        url: orderURLs.updateData,
        data: {
            id: allRowData?.id,
            ProductId: allRowData?.ProductId,
            quantity: allRowData?.quantity,
            manualPrice: false,
            updatePrice: true,
        }
    })
    return (
        <ModalSmallFilled translations={{
            title: t('sureSyncPriceProductPrice', '¿Seguro que quieres volver a sincronizar el precio de este producto?'),
            subtitle: t('productRecoverOriginalPrice', 'El producto recuperará el precio original correspondiente a su tarifa'),
            buttonAccept: t('sync', 'Sincronizar')
        }} onAccept={() => { handleFetchText(); setOpened(null) }} opened={true} setOpened={() => setOpened(null)} />
    )
}


export default ModalSyncProductPriceOrder